import Pages from '../pages';
import ParticipantPages from '../pages/participants';
import AuthCheck from '../pages/auth-check';
import TentPages from '../pages/tents';
import ParticipantAssignment from '../pages/tents/participant-assignment';
import NotFound from '../pages/Notfound';

const { Login, KeyInput, Dashboard, Registration } = Pages();
const { Participants, Enrollment, Kitchen, Medical, Media, Archive } =
    ParticipantPages();

const { Tents } = TentPages();

export const Routes = [
    {
        name: 'home',
        url: '/',
        component: () => (
            <AuthCheck pageType="login">
                <Login />
            </AuthCheck>
        ),
    },
    {
        name: 'login',
        url: '/login',
        component: () => (
            <AuthCheck pageType="login">
                <Login />
            </AuthCheck>
        ),
    },
    {
        name: 'keyInput',
        url: '/key-input',
        component: () => (
            <AuthCheck pageType="keyInput">
                <KeyInput />
            </AuthCheck>
        ),
    },
    {
        name: 'dashboard',
        url: '/dashboard',
        component: () => (
            <AuthCheck pageType="dashboard">
                <Dashboard />
            </AuthCheck>
        ),
    },
    {
        name: 'participants',
        url: '/participants',
        component: () => (
            <AuthCheck pageType="participants">
                <Participants />
            </AuthCheck>
        ),
    },
    {
        name: 'participant-assignment',
        url: '/participant-assignment/:id',
        component: () => (
            <AuthCheck pageType="participant-assignment">
                <ParticipantAssignment />
            </AuthCheck>
        ),
    },

    {
        name: 'enrollments',
        url: '/participants/enrollments',
        component: () => (
            <AuthCheck pageType="enrollments">
                <Enrollment />
            </AuthCheck>
        ),
    },
    {
        name: 'kitchen',
        url: '/participants/kitchen',
        component: () => (
            <AuthCheck pageType="kitchen">
                <Kitchen />
            </AuthCheck>
        ),
    },
    {
        name: 'medical',
        url: '/participants/medical',
        component: () => (
            <AuthCheck pageType="medical">
                <Medical />
            </AuthCheck>
        ),
    },
    {
        name: 'media',
        url: '/participants/media',
        component: () => (
            <AuthCheck pageType="media">
                <Media />
            </AuthCheck>
        ),
    },
    {
        name: 'archives',
        url: '/participants/archive',
        component: () => (
            <AuthCheck pageType="archives">
                <Archive />
            </AuthCheck>
        ),
    },
    {
        name: 'tent-management',
        url: '/tent-management',
        component: () => (
            <AuthCheck pageType="tent-management">
                <Tents />
            </AuthCheck>
        ),
    },
    {
        name: 'not-found',
        url: '*',
        component: () => (
            <AuthCheck pageType="not-found">
                <NotFound />
            </AuthCheck>
        ),
    },
];
